import React from 'react';
import { Vertify } from '@alex_xu/react-slider-vertify';
import { useTranslation } from "react-i18next";
import './slider.less'

export default function SliderModal({ setSlider, sliderVisible }) {
  const { t } = useTranslation();
  // document.getElementsByClassName("sliderText")[0].textContent = "拖动滑块最右以获取验证码";
  return (
    <>
      <Vertify
        width={335}
        height={80}
        text={t("请按住滑块拖动完成拼图")}
        visible={sliderVisible}
        onSuccess={() => {
          setSlider(false);
        }}
        onFail={() => {
          setSlider(true);
        }}
        onRefresh={() => {
          setSlider(true);
        }}
      />
    </>
  );
}
